import { FunctionComponent } from "react";

const CoralCloseIcon: FunctionComponent = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.3384 2.75609L0.63129 2.04898L2.04551 0.634766L2.75261 1.34187L8.99848 7.58774L15.2443 1.34187L15.9514 0.634766L17.3657 2.04898L16.6586 2.75609L10.4127 9.00195L16.6586 15.2478L17.3657 15.9549L15.9514 17.3691L15.2443 16.662L8.99848 10.4162L2.75261 16.662L2.04551 17.3691L0.63129 15.9549L1.3384 15.2478L7.58426 9.00195L1.3384 2.75609Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default CoralCloseIcon;
